export var toggleCarrotquestMessenger = function (mode) {
    var messengerElement = document.querySelector('#carrotquest-messenger-collapsed-container');
    if (!messengerElement)
        return;
    messengerElement.style.display = mode === 'hide' ? 'none' : 'block';
};
